export const UNAVAILABLE_DOC_ID = 'UNAVAILABLE_DOC_ID'
